import React from 'react';
import cn from 'classnames';
import Image from '@base/lib/ThemeImage';
import styles from '@pro/lib/ThemeEmpty.module.less';
import { getCdnUrl } from 'base/utils/trans-path';
import { useTrans } from 'base/utils/i18n';
import { theme } from 'pro/config/theme';

type ThemeEmptyProps = {
    className?: string;
    type?: string;
    image?: string;
    tip?: React.ReactNode;
    extra?: React.ReactNode;
};

type IConfigItem = {
    image: string;
    tip: string;
}

export const config: Record<string, IConfigItem> = {
    address: {
        image: 'asset/width-152/picture/74eb747a85fe8a9b8802f37e1471c576.png',
        tip: 'web_address_empty_tip',
    },
    cart: {
        image: 'asset/width-304/picture/445b2af75e0a336ae9c8ca71cf362e60.png',
        tip: 'web_cart_empty_tip',
    },
    coupon: {
        image: 'asset/width-152/picture/70de43ae42295cdc05db55fbb24aac33.png',
        tip: 'web_coupon_empty_tip',
    },
    order: {
        image: 'asset/width-152/picture/2ac879d2f072708ac670a50178b26165.png',
        tip: 'web_order_empty_tip',
    },
    search: {
        image: 'asset/width-152/picture/adf5236406368f44ccaae6f2f9c3c714.png',
        tip: 'web_search_empty_tip',
    },
    error: {
        image: 'asset/width-152/picture/b1edc5dbdeb589d7d8b683a53714292b.png',
        tip: 'web_common_empty_tip',
    },
    filter: {
        image: 'asset/width-152/picture/bf0f4e9469461aa20815b07845d548d5.png',
        tip: 'web_list_filter_empty_tip'
    },
    comment: {
        image: 'asset/width-152/picture/1f58a36725dfa311b2176427bf8ff2bb.png',
        tip: 'web_review_empty_tip'
    },
};

const ThemeEmpty: React.FC<ThemeEmptyProps> = props => {
    const { className, type = 'error', image, tip, extra } = props;
    const item = type in config ? config[type] : config.error;
    const size = 76
    const { t } = useTrans()

    return (
        <div className={cn(className, styles.empty)}>
            <Image
                src={image ? getCdnUrl(image) : getCdnUrl(theme.emptyIcons?.[type] || item.image)}
                fixed
                width={size}
                height={size}
                background={false}
            />

            <div className="tip">{tip || t(item.tip)}</div>

            {extra && (
                <div className="extra">
                    {extra}
                </div>
            )}
        </div>
    )
};

export default ThemeEmpty;
